import React, { Component } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash'
import {
  Modal,
  Button,
  FileUploader,
  TextArea,
  Checkbox,
  RadioButton,
  ProgressIndicatorSkeleton,
} from 'carbon-components-react';
import Select from 'react-select';
import queryString from 'qs';
import NumberFormat from 'react-number-format';
import ModalDm from '../../../../components/Modal/ModalDm';
import { Breadcrumb, Card, Notification } from '../../../../components';
import {
  getByDmService,
  deleteDmService,
  insertDmService,
  updateDmService,
  getDmService,
} from '../../../../services/Api';
import appConfig from '../../../../config/app-config';

import 'numeral/locales/pt-br';


const { IMAGE_PATH } = appConfig;
const unidadesMedida = [
  { label: 'NA', id: '1' },
  { label: 'CM', id: '2' },
  { label: 'M2', id: '3' },
  { label: 'Unid', id: '4' },
  { label: 'Pixel', id: '5' },
  { label: 'Polegada', id: '6' },
  { label: 'Segundos', id: '7' },
];

class Agencia extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false; // Adicione esta linha
    this.state = {
      tipos: [],
      tipoSelecionado: { id: 0 },
      uploads: [],
      QuantidadeMinima: '',
      PrecoReferencia: 0,
      OrcamentoObrigatorio: false,
      UploadReferenciaObrigatorio: false,
      BriefingObrigatorio: false,
      selectedAplicacaoItems: [],
      selectedTamanhos: [],
      listFornecedores: [],
      MultSelecaoTamanhos: false,
      UtilizadoEmTrade: false,
      tagPriceModal: false,
      listFornecedoresTags: [],
      selectedFornecedoresTag: [],
      selectedFornecedores: [],
      providerSelecteds: [],
      fornecedoresTag: [],
      fornecedores: [],
      tagsPrices: [],
      bloquedSelectedMensure: false,
      disabledGroupSelected: false,
      confirmFree: false,
      precoReferenciaTag: {
        value: '',
        floatValue: 0
      },
      listGroups: [],
      tamanhoFixo: false,
    };
  }

  componentDidMount = async () => {
    this._isMounted = true; // Adicione esta linha
    await this.loadGroups();
    await this.getItems();
    await this.getGroups();
  };

  componentWillUnmount() {
    this._isMounted = false; // Adicione esta linha
  }

  goUrl = () => {
    const { history } = this.props;
    const urlGo = '/admin/produtos/1';
    history.push(urlGo);
  };

  getItems = async () => {
    const { match, location } = this.props;
    const { listFornecedores } = this.state;

    let data = { produtoCategoria: { id: 0, tipo: 1 } };
    const query = queryString.parse(location.search.slice(1));

    const { msg } = query;
    if (msg) {
      toast.success(msg);
    }
    try {
      if (Number(match.params.id) === 0) {
        data = { produtoCategoria: { id: 0 } };
      } else {
        data = await getByDmService('/ProdutoAgencia', match.params.id);
      }


      const tipos = [{ id: '1', label: 'Agência' }, { id: '2', label: 'Trade' }];
      const tipoSelecionado = { id: '1', label: 'Agência' };


      const selectedAplicacaoItems = data.listaAplicacoes ? data.listaAplicacoes.map(item => (item.id)) : [4];
      const selectedTamanhos = data.listaTamanhos ? data.listaTamanhos.map(item => (item.id)) : [];
      await this.loadTagsProviderGroup(data)

      if (this._isMounted) {
        await this.setState(
          {
            ativo: data.ativo,
            isLoading: false,
            tipoSelecionado,
            tipos,
            selectedAplicacaoItems,
            selectedTamanhos,
            listFornecedores,
            QuantidadeMinima: data.quantidadeMinima,
            PrecoReferencia: data.precoReferencia || 0,
            UploadReferenciaObrigatorio: data.uploadReferencia,
            BriefingObrigatorio: data.briefing,
            fotos: data.fotos,
            codigo: data.codigo,
            tamanhoFixo: data.tamanhoFixo
          },

          async () => {
            await this.loadGroups(data.idGrupo);
            await this.loadProducts(data.idProduto);
            await this.loadMaterials(data.idMaterial);
            await this.loadDetails(data.idDetalhe);
            await this.loadFornecedores();
            await this.loadAplicacao();
            await this.loadTamanhos();
          },
        );
      }
    } catch (e) {
      if (this._isMounted) {
        if (e.message) toast.error(e.message);
        else toast.error('Ocorreu um erro ao carregar os dados');
      }
    }
  };


  getGroups = async () => {
    const { grupos } = this.state;
    const _groups = await getDmService('/ProdutoCategoria/GetByTipo/?tipo=1');
    const groupsSelects = _groups.map(value => ({
      id: value.id,
      label: value.nome,
      selected: grupos && grupos.filter(p => p === value.id).length > 0
    }));
    this.setState({
      listGroups: groupsSelects
    },
      async () => {
        this.loadFornecedoresTags();
      });
  };

  onCheckGroup = (e, id) => {
    const { listGroups } = this.state;
    listGroups.find(p => p.id === id).selected = e;
    this.setState({ listGroups }, () => {
      this.loadFornecedoresTags();
    })
  }


  loadDetails = async selectedId => {
    const { selectedProduct } = this.state;
    if (selectedProduct) {
      const list = await getByDmService('/Detalhe/GetByProduto', `?produto=${selectedProduct.id}`);
      const details = list.map(item => ({ id: item.id, label: item.descricao }));
      let selectedDetail = details.find(el => el.id === selectedId);
      const idxFirst = 0;
      if (selectedDetail == null && details && details.length === 1) {
        selectedDetail = details[idxFirst];
      }
      this.setState({ selectedDetail, details });
    }
  };

  loadAplicacao = async () => {
    const list = await getByDmService('/Aplicacao', '');
    const { selectedAplicacaoItems } = this.state;
    const aplicacoes = await list.map(item => ({
      id: item.id,
      label: item.nome,
      checked: selectedAplicacaoItems && (selectedAplicacaoItems.indexOf(item.id) > -1)
    }));

    const aplications = aplicacoes.sort()
    this.setState({ aplicacoes: aplications });
  };

  loadTamanhos = async () => {
    const { gruposelecionada } = this.state;
    if (gruposelecionada) {
      const list = await getByDmService('/Tamanho/GetByGrupo/', `?grupo=${gruposelecionada.id}&nomeProduto=`);
      const { selectedTamanhos } = this.state;
      const tamanhos = list.map(item => ({
        id: item.id,
        label: item.nome,
        checked: selectedTamanhos && selectedTamanhos.indexOf(item.id) > -1,
      }));

      this.setState({ tamanhos });
    }
  };

  loadFornecedoresTags = async () => {
    const {
      gruposelecionadaTag
    } = this.state;

    if (gruposelecionadaTag) {

      const list = await getByDmService('/Fornecedor/GetByGrupo/', `?grupo=${gruposelecionadaTag.id}&nomeProduto=`);

      const fornecedoresTag = list.map(item => ({
        id: item.id,
        label: item.nomeFantasia,
        checked: false,
      }));

      const listFornecedoresTags = [];
      this.setState({
        fornecedoresTag,
        listFornecedoresTags
      });
    }
  }

  loadFornecedores = async () => {
    const { gruposelecionada } = this.state;
    if (gruposelecionada) {
      const list = await getByDmService('/Fornecedor/GetByGrupo/', `?grupo=${gruposelecionada.id}&nomeProduto=`);
      const { selectedFornecedores } = this.state;

      const fornecedores = list.map(item => ({
        id: item.id,
        label: item.nomeFantasia,
        checked: false,
      }));
      const listFornecedores = [];
      if (selectedFornecedores !== undefined && selectedFornecedores.length) {
        selectedFornecedores.forEach(item => {
          const fornecedor = fornecedores.find(
            el => parseInt(el.id, 10) === parseInt(item.id, 10),
          ) || { id: 0, label: '' };
          listFornecedores.push({
            id: item.id,
            preco: item.preco,
            selected: { id: fornecedor.id, label: fornecedor.label },
          });
        });

      }


      this.setState({ fornecedores, listFornecedores }, () => {
        if (selectedFornecedores.length === 0 && fornecedores.length > 0)
          this.handleFornecedorItem(null, -1);
      });
    }
  };

  loadMaterials = async selectedId => {
    const { gruposelecionada } = this.state;
    const idGroup = gruposelecionada && gruposelecionada.id ? gruposelecionada.id : 0;

    const list = await getDmService(`material/GetByGrupo/?grupo=${idGroup}&nomeProduto=`);
    const materials = list.map(item => ({ id: item.id, label: item.nome }));
    const idxMaterial = 0;
    let selectedMaterial = materials.find(el => el.id === selectedId);
    if (selectedMaterial == null && materials && materials.length === 1) {
      selectedMaterial = materials[idxMaterial];
    }
    this.setState({ selectedMaterial, materials });
  };

  loadProducts = async selectedId => {
    const { gruposelecionada } = this.state;
    if (gruposelecionada) {
      const list = await getByDmService(
        '/ProdutoDescricao/GetByGrupo/',
        `?grupo=${gruposelecionada.id}&nomeProduto=`,
      );
      const products = list.map(item => ({ id: item.id, label: item.nome }));
      const idxProduct = 0;
      let selectedProduct = products.find(el => el.id === selectedId);
      if (selectedProduct == null && products && products.length === 1) {
        selectedProduct = products[idxProduct];
      }
      this.setState({ selectedProduct, products }, async () => {
        await this.loadDetails(selectedProduct ? selectedProduct.id : 0);
      });
    }
  };

  loadGroups = async selectedId => {
    const { tipoSelecionado } = this.state;
    let grupos = [];
    const cat = await getByDmService('/ProdutoCategoria/GetByTipo', `?tipo=${tipoSelecionado.id}`);

    grupos = cat.map(item => ({ id: item.id, label: item.nome }));
    const gruposelecionada = grupos.find(el => el.id === selectedId);
    const disabledGroupSelected = gruposelecionada !== undefined
    this.setState({
      gruposelecionada,
      gruposelecionadaTag: gruposelecionada,
      grupos,
      disabledGroupSelected
    }, async () => {

      await this.loadProducts(0);
      await this.loadTamanhos();
      await this.loadFornecedores();
      await this.loadFornecedoresTags()

    });
  };


  loadTagsProviderGroup = async (data) => {
    const { gruposelecionada } = this.state
    let tagsPrices = [];

    if (data && Object.prototype.hasOwnProperty.call(data, "idGrupo")) {
      try {
        const tags = await getDmService(`/TagPreco/GetByGrupo?grupo=${data.idGrupo}`);

        tagsPrices = await tags.map(item => ({
          id: item.id,
          label: item.nome,
          precoReferencia: item.precoReferencia,
          unidadeMedida: item.unidadeMedida
        }));

        let selectedTagPrice = tagsPrices.length === 1 ? tagsPrices[0] : null;
        let unidadeMedidaSelecionada = []
        let selectedTag = [];
        if (tagsPrices.length) {
          selectedTag = await tagsPrices.filter(item => parseInt(item.id, 10) === data.idTagPreco);
          // console.log("selectedTag", selectedTag)
          if (selectedTag.length) {
            unidadeMedidaSelecionada = await unidadesMedida.filter(el => parseInt(el.id, 10) === selectedTag[0].unidadeMedida);
            selectedTagPrice = await selectedTag[0]
          }

        }

        await this.setState({
          tagsPrices,
          selectedTagPrice,
          unidadeMedidaSelecionada: unidadeMedidaSelecionada ? unidadeMedidaSelecionada[0] : null,
        });
      } catch (error) {
        toast.warn(error.message)
      }

    } else {

      tagsPrices = [];
      if (gruposelecionada !== undefined) {
        const tags = await getDmService(`/TagPreco/GetByGrupo?grupo=${gruposelecionada.id}`);

        tagsPrices = await tags.map(item => ({
          id: item.id,
          label: item.nome,
          precoReferencia: item.precoReferencia,
          unidadeMedida: item.unidadeMedida
        }));

        const selectedTagPrice = tagsPrices.length === 1 ? tagsPrices[0] : null;
        await this.setState({
          tagsPrices,
          selectedTagPrice
        })

      }
    }
  };

  salvar = async () => {
    const { match } = this.props;
    const {
      gruposelecionada,
      uploads,
      selectedProduct,
      selectedMaterial,
      selectedDetail,
      selectedAplicacaoItems,
      selectedTamanhos,
      QuantidadeMinima,
      UploadReferenciaObrigatorio,
      BriefingObrigatorio,
      selectedTagPrice
    } = this.state;


    try {
          const data = {
            IdGrupo: gruposelecionada.id,
            IdProduto: selectedProduct.id,
            IdMaterial: selectedMaterial.id,
            IdDetalhe: selectedDetail ? selectedDetail.id : null,
            SalvaAplicacoes: Array.isArray(selectedAplicacaoItems) ? selectedAplicacaoItems : [],
            SalvaTamanhos: Array.isArray(selectedTamanhos) ? selectedTamanhos : [],
            QuantidadeMinima,
            UploadReferencia: UploadReferenciaObrigatorio,
            Briefing: BriefingObrigatorio,
            IdTagPreco: selectedTagPrice && selectedTagPrice.id ? selectedTagPrice.id : 0,
          };


      if (match.params.id && match.params.id > 0)
        await updateDmService('ProdutoAgencia', match.params.id, data);
      else {
        const result = await insertDmService('ProdutoAgencia', data);
        if (uploads.length > 0) await this.uploadFileArray(uploads, result);
      }
      toast.success('Dados registrados com sucesso');
      this.goUrl();
    } catch (e) {
      if (e && e.message) {
        toast.warn(e.message);
      } else {
        toast.error('Falha ao salvar os dados');
      }
    }
  };

  criarGrupo = async () => {
    const { tipoSelecionado, descricaoGrupo, nomeGrupo, MultSelecaoTamanhos, UtilizadoEmTrade } = this.state;
    try {
      const data = {
        Tipo: tipoSelecionado.id,
        Nome: nomeGrupo,
        Descricao: descricaoGrupo,
        MultSelecaoTamanhos,
        UtilizadoEmTrade
      };
      const cat = await insertDmService('ProdutoCategoria', data);

      await this.loadGroups(cat.id);
      this.setState({ grupoModal: false, nomeGrupo: '', descricaoGrupo: '' });
    } catch (e) {
      toast.error('Falha ao criar grupo');
    }
  };

  createProduct = async () => {
    const { gruposelecionada, productName, productDescription } = this.state;
    try {
      const data = {
        Grupo: { id: gruposelecionada.id },
        Nome: productName,
        Descricao: productDescription,
      };
      const obj = await insertDmService('ProdutoDescricao', data);

      await this.loadProducts(obj.id);
      this.setState({ productModal: false, productName: '', productDescription: '' });
    } catch (e) {
      toast.error('Falha ao criar o Nome do Produto');
    }
  };

  createMaterial = async () => {
    const { materialName, gruposelecionada } = this.state;
    try {
      const data = {
        Grupo: { id: gruposelecionada.id },
        Nome: materialName,
      };
      const obj = await insertDmService('Material', data);
      await this.loadMaterials(obj.id);
      this.setState({ materialModal: false, materialName: '' });
    } catch (e) {
      toast.error('Falha ao criar o Material');
    }
  };

  createDetail = async () => {
    const { detailName, selectedProduct } = this.state;
    try {
      const data = {
        descricao: detailName,
        Produto: { id: selectedProduct.id },
      };
      const obj = await insertDmService('Detalhe', data);
      await this.loadDetails(obj.id);
      this.setState({ detailModal: false, detailName: '' });
    } catch (e) {
      toast.error('Falha ao criar o Detalhe');
    }
  };

  createAplicacao = async () => {
    const {
      selectedAplicacaoItems,
      aplicacaoComplemento,
      aplicacaoNome,
      aplicacaoUnico,
      aplicacaoFracionado,
      aplicacaoSequencial,
    } = this.state;
    try {
      const data = {
        nome: aplicacaoNome,
        ExigeComplmento: aplicacaoComplemento === 1,
        Unico: aplicacaoUnico,
        Fracionado: aplicacaoFracionado,
        Sequencial: aplicacaoSequencial,
      };
      const obj = await insertDmService('Aplicacao', data);
      selectedAplicacaoItems.push(obj.id);
      this.setState(
        {
          selectedAplicacaoItems,
          aplicacaoComplemento: 0,
          aplicacaoModal: false,
          aplicacaoNome: '',
          aplicacaoUnico: false,
          aplicacaoFracionado: false,
          aplicacaoSequencial: false,
        },
        async () => {
          await this.loadAplicacao();
        },
      );
    } catch (e) {
      toast.error('Falha ao criar a Aplicação');
    }
  };

  createTamanho = async () => {
    const {
      selectedTamanhos,
      gruposelecionada,
      tamanhoNome,
      unidadeMedidaTamanho,
      tamanhoLarguraObrigatoria,
      tamanhoLargura,
      tamanhoAltura,
      tamanhoAlturaObrigatoria,
      tamanhoFixo
    } = this.state;
    try {
      const data = {
        Nome: tamanhoNome,
        Grupo: { id: gruposelecionada.id },
        UnidadeMedida: unidadeMedidaTamanho.id,
        Largura: parseFloat(tamanhoLargura),
        Altura: parseFloat(tamanhoAltura),
        LarguraObrigatoria: tamanhoLarguraObrigatoria,
        AlturaObrigatoria: tamanhoAlturaObrigatoria,
        isLarguraVariavel: tamanhoLarguraObrigatoria,
        isAlturaVariavel: tamanhoAlturaObrigatoria,
        tamanhoFixo
      };
      const obj = await insertDmService('Tamanho', data);
      selectedTamanhos.push(obj.id);
      this.setState(
        {
          selectedTamanhos,
          tamanhosModal: false,
          tamanhoNome: '',
          aplicacaoUnico: false,
          unidadeMedidaTamanho: { id: 0, label: '' },
        },
        async () => {
          await this.loadTamanhos();
        },
      );
    } catch (e) {
      toast.error('Falha ao criar o Tamanho');
    }
  };

  onChangeText = (event, value) => {
    if (value) {
      this.setState({ [event.target.name]: value });
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  onChangeNumber = event => {
    const val = parseFloat(event.target.value.replace(/^0+/, ''), 10);
    if (val >= 1 || val === "") {
      this.setState({ [event.target.name]: val });
    } else {
      this.setState({ [event.target.name]: val });
    }

  };

  onChangeGrupo = async obj => {
    this.setState({
      gruposelecionada: obj,
      gruposelecionadaTag: obj,
      details: [],
      selectedDetail: null,
      disabledGroupSelected: true
    }, async () => {
      await this.loadProducts(0);
      await this.loadMaterials()
      await this.loadTamanhos();
      await this.loadTagsProviderGroup();
      await this.loadFornecedores();
      await this.loadFornecedoresTags()

    });
  };

  onChangeGrupoTag = async obj => {
    this.setState({
      gruposelecionadaTag: obj,
      gruposelecionada: obj
    }, async () => {
      this.loadFornecedoresTags()
    })
  }

  onChangeProduct = async obj => {
    this.setState({ selectedProduct: obj }, async () => {
      await this.loadDetails(0);
    });
  };

  onChangeFornecedor = async obj => {
    this.setState({ selectedFornecedorTag: obj }, async () => {
      await this.loadTagsProviderGroup();
    });
  }

  onChangeFornecedorTag = async obj => {
    this.setState({ selectedFornecedorTag: obj }, async () => {
      await this.loadTagsProviderGroup();
    });
  }

  onChangeCombo = async (obj, name) => {
    this.setState({ [name]: obj });
  };

  onChangeTipo = tipo => {
    const { history } = this.props;
    if (tipo.id === '2') history.push('/admin/produto/0');
  };

  onChangeMessage = event => {
    this.setState({ descricao: event.target.value });
  };

  onChangeComplemento = obj => {
    this.setState({ aplicacaoComplemento: obj });
  };

  onChangeCheck = (val, id, event) => {
    this.setState({ [event.target.name]: val });
  };

  onChangeNameTag = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  onChangePriceTag = event => {
    this.setState({ precoReferenciaTag: event });
  }

  onChangePriceProviders = event => {
    this.setState({ precoFornecedor: event });
  }

  onChangeTagPrice = async selectedTagPrice => {

    let selectedUnidaMensure = []

    if (selectedTagPrice && Object.prototype.hasOwnProperty.call(selectedTagPrice, "unidadeMedida")) {
      selectedUnidaMensure = unidadesMedida.filter(item => parseInt(item.id, 10) === selectedTagPrice.unidadeMedida);
    }

    this.setState({
      selectedTagPrice,
      unidadeMedidaSelecionada: selectedUnidaMensure ? selectedUnidaMensure[0] : null,
      bloquedSelectedMensure: true
    })
  };

  deleteFoto = async id => {
    try {
      await deleteDmService('/ProdutoAgencia/DeleteFoto', id);
      await this.reloadFotos();
    } catch (err) {
      toast.error(err.message);
    }
  };

  onChangeAplicacaoCheck = (val, _id) => {
    const { selectedAplicacaoItems } = this.state;
    const aplications = _.clone(selectedAplicacaoItems, true)
    const index = aplications.indexOf(_id);

    if (!val) {
      aplications.splice(index, 1);
    } else if (val) {
      aplications.push(_id);
    }

    this.setState({ selectedAplicacaoItems: aplications });
  };

  onChangeTamanhoCheck = (val) => {
    const { tamanhos } = this.state;
    const copySizes = _.clone(tamanhos, true);
    const selectedTamanhos = []
    for (const obj of copySizes) {
      if (obj.id === val.id) {
        obj.checked = !obj.checked;
      }
      if (obj.checked === true) {
        selectedTamanhos.push(obj.id);
      }
    }

    this.setState({
      tamanhos: copySizes,
      selectedTamanhos
    })

  };

  fileChange = async (e, name) => {
    const { match } = this.props;
    const { files } = document.getElementsByName(name)[0];
    if (files.length > 0) {
      if (match.params.id > 0) {
        const _files = [];
        for (let i = 0; i < files.length; i++) _files.push(files[i]);

        await this.uploadFileArray(_files, match.params.id);
        setTimeout(async () => {
          await this.reloadFotos();
        }, 750);
        this.fileUploader.clearFiles();
      } else {
        this.setState(prevState => {
          const uploads = prevState.uploads || [];
          for (let i = 0; i < files.length; i++) uploads.push(files[i]);
          return { ...prevState, uploads };
        });
      }
    }
  };

  uploadFileArray = async (files, id) => {
    // await Promise.all(
    files.map(async file => {
      try {
        const data = new FormData();
        data.append('file', file);
        await insertDmService(`/ProdutoAgencia/Upload?idProduto=${id}&principal=false`, data);
      } catch (err) {
        toast.error('Falha ao fazer upload da foto');
      }
    });
    // );
  };

  fFoto = async id => {
    try {
      await deleteDmService('/ProdutoAgencia/DeleteFoto', id);
      await this.reloadFotos();
    } catch (err) {
      toast.error(err.message);
    }
  };

  reloadFotos = async () => {
    const { match } = this.props;
    const data = await getByDmService('/ProdutoAgencia', match.params.id);
    this.setState({ fotos: data.fotos });
  };

  deletarProduto = async () => {
    const { match } = this.props;
    try {
      await deleteDmService('ProdutoAgencia', match.params.id);
      toast.success('Item excluído com sucesso');
      this.setState({ deleteModal: false });
      this.goUrl();
    } catch (e) {
      toast.error(e.message);
    }
  };

  onsubmit = e => {
    e.preventDefault();
    const { selectedAplicacaoItems } = this.state;

    if (e.target.checkValidity()) {
      if (!selectedAplicacaoItems.length) {
        toast.warn("Você precisa selecionar uma aplicação");
      } else {
        this.salvar();
      }
    }
  };

  cleseModal = modal => {
    this.setState({ [modal]: false });
  };

  openModal = modal => {
    this.setState({ [modal]: true });
  };

  handleFornecedorItem = (e, index) => {
    if (e) e.preventDefault();
    const { listFornecedores } = this.state;
    if (index + 1 === listFornecedores.length) {
      listFornecedores.push({ id: 0, preco: 0, selected: { id: 0, label: '' } });
    } else {
      listFornecedores.splice(index, 1);
    }
    this.setState({ listFornecedores });
  };


  saveTagPrice = async () => {
    const {
      nameTagPrice,
      precoReferenciaTag,
      providerSelecteds,
      unidadeMedidaTag,
      OrcamentoObrigatorio,
      listGroups,
      confirmFree
    } = this.state;

    const idsProviders = providerSelecteds.map(item => ({
      idFornecedor: item.selectedFornecedorTag.id,
      preco: item.precoFornecedor.floatValue
    }))

    if (!nameTagPrice) {
      toast.warn('Informe o nome da Tag de preço');
    } else if (!unidadeMedidaTag) {
      toast.warn('Informe a unidade de medida');
    } else {
      const confirmSave = (typeof precoReferenciaTag === "object" && precoReferenciaTag.floatValue > 0) || OrcamentoObrigatorio ? true : confirmFree;

      if (confirmSave) {
        try {
          const data = await insertDmService("/TagPreco", {
            Nome: nameTagPrice,
            PrecoReferencia: OrcamentoObrigatorio ? typeof precoReferenciaTag === "object" ? precoReferenciaTag.floatValue : 0 : 0,
            Fornecedores: idsProviders,
            UnidadeMedida: unidadeMedidaTag.id,
            OrcamentoObrigatorio,
            grupos: listGroups.filter(p => p.selected).map(p => p.id)
          });

          await this.loadTagsProviderGroup();
          const selectedTagPrice = await { id: data.id, label: data.nome, precoReferencia: data.precoReferencia }
          const selectedUnidaMensure = await unidadesMedida.filter(item => item === unidadeMedidaTag);
          const unidadeMedidaSelecionada = await selectedUnidaMensure[0];

          await this.setState({
            unidadeMedidaSelecionada,
            selectedTagPrice,
            bloquedSelectedMensure: true,
            tagPriceModal: false,
            PrecoReferencia: selectedTagPrice.precoReferencia,
            confirmFree: false
          });

          await toast.success("Tag de preço adicionada com sucesso!")

        } catch (error) {
          console.log("error", error)
          toast.warn(error.message);
        }
      } else {
        this.setState({
          openMdConfirmFree: true,
          confirmFree: false
        })
      }
    }

  }

  closeConfirmTag = (event) => {
    console.log("event", event);
    if (event) {

      this.setState({
        openMdConfirmFree: false,
        confirmFree: true
      }, () => {
        this.saveTagPrice();
      });
    } else {
      this.setState({
        openMdConfirmFree: false,
        confirmFree: false
      });
    }
  }

  addFornecedorTag = () => {
    const { providerSelecteds, selectedFornecedorTag, precoFornecedor } = this.state;
    const listProviders = _.clone(providerSelecteds, true)
    const listProvidersTemp = listProviders.map(item => item.selectedFornecedorTag)

    if ((listProvidersTemp.indexOf(selectedFornecedorTag) === -1)) {
      listProviders.push({
        selectedFornecedorTag,
        precoFornecedor
      });
    }

    this.setState({
      providerSelecteds: listProviders
    })
  }

  editPrecoFornecedor(event, index) {

    const { providerSelecteds } = this.state;
    const listProviders = _.clone(providerSelecteds, true);
    const newsValues = []
    listProviders.forEach((item, idx) => {
      if (idx === index) {
        item.precoFornecedor = event
      }
      newsValues.push(item);
    });

    this.setState({
      providerSelecteds: newsValues
    })
    console.log("listProviders", newsValues);
  }

  removeProviderSelectedts = index => {
    const { providerSelecteds } = this.state;
    const listProviders = _.clone(providerSelecteds, true);
    listProviders.splice(index, 1);
    this.setState({
      providerSelecteds: listProviders
    });
  }


  render() {
    const {
      isLoading,
      nome,
      fotos,
      gruposelecionada,
      grupos,
      // tipos,
      // tipoSelecionado,
      selectedProduct,
      products,
      deleteModal,
      grupoModal,
      materialModal,
      productModal,
      selectedDetail,
      descricaoGrupo,
      nomeGrupo,
      productDescription,
      productName,
      selectedMaterial,
      materials,
      materialName,
      detailModal,
      aplicacaoModal,
      tamanhosModal,
      detailName,
      details,
      QuantidadeMinima,
      unidadeMedidaSelecionada,
      OrcamentoObrigatorio,
      UploadReferenciaObrigatorio,
      BriefingObrigatorio,
      aplicacaoSequencial,
      aplicacaoFracionado,
      aplicacaoUnico,
      aplicacaoNome,
      aplicacaoComplemento,
      // aplicacoes,
      tamanhos,
      tamanhoNome,
      unidadeMedidaTamanho,
      tamanhoLarguraObrigatoria,
      tamanhoLargura,
      tamanhoAltura,
      tamanhoAlturaObrigatoria,
      MultSelecaoTamanhos,
      UtilizadoEmTrade,
      codigo,
      // tagsPrices,
      selectedTagPrice,
      tagPriceModal,
      selectedFornecedorTag,
      nameTagPrice,
      fornecedoresTag,
      precoReferenciaTag,
      providerSelecteds,
      unidadeMedidaTag,
      precoFornecedor,
      openMdConfirmFree,
      listGroups,
      tamanhoFixo
    } = this.state;
    const { match } = this.props;
    const idProd = codigo || ""
    const disabledBtnAddProviders = selectedFornecedorTag === undefined || precoFornecedor === undefined;

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />
          <section className="content-wrapper content-wrapper--large">
            <ProgressIndicatorSkeleton />
          </section>
        </div>
      );
    }

    return (
      <div>
        {!isLoading && (
          <div>
            <Breadcrumb
              title="Produto Agência"
              description={nome}
              renderRight={
                match.params.id > 0 &&
                (() => (
                  <button
                    onClick={() => {
                      this.openModal('deleteModal');
                    }}
                    type="submit"
                    className="bx--btn btn-primary-outlined h-sm-margin"
                  >
                    Excluir Produto
                  </button>
                ))()
              }
              renderLeft={(() => (
                <div className="breadcrumb-left-actions pointer" onClick={() => this.goUrl()}>
                  <svg width="16" height="14" viewBox="0 0 16 14">
                    <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                  </svg>
                </div>
              ))()}
            />
            <section className="content-wrapper content-wrapper--large product-edit">
              <div className="table-uniforms">
                <Card className="center-box">
                  <form onSubmit={this.onsubmit}>
                    <div className="mg-left-20">
                      {idProd !== "" && (
                        <div className="row">
                          <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                            <label className="bx--label">
                              ID DO PRODUTO:
                              {` ${idProd}`}
                            </label>
                          </div>
                        </div>
                      )}
                      {/* <div className="bx--row">

                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Tipo</label>
                          <Select
                            className="search-dm"
                            name="tipo"
                            required
                            options={tipos}
                            value={tipoSelecionado}
                            onChange={this.onChangeTipo}
                            placeholder="Tipo"
                            isClearable={false}
                            isSearchable
                          />
                        </div>
                      </div> */}
                      {/* <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Grupo</label>
                          <Select
                            className="search-dm"
                            name="grupos"
                            options={grupos}
                            required
                            value={gruposelecionada}
                            onChange={this.onChangeGrupo}
                            placeholder="Grupo"
                            isClearable={false}
                            isSearchable
                          />
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">&nbsp;</label>
                          <div className="clearfix" />
                          <a
                            className="gerenciar-categoria"
                            onClick={() => {
                              this.openModal('grupoModal');
                            }}
                          >
                            Criar Grupo
                          </a>
                        </div>
                      </div> */}
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Nome do Produto</label>
                          <Select
                            className="search-dm"
                            name="products"
                            options={products}
                            required
                            value={selectedProduct}
                            onChange={this.onChangeProduct}
                            placeholder="Nome do Produto"
                            isClearable={false}
                            isSearchable
                          />
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">&nbsp;</label>
                          <div className="clearfix" />
                          <a
                            className="gerenciar-categoria"
                            onClick={() => {
                              this.openModal('productModal');
                            }}
                          >
                            Criar Nome do Produto
                          </a>
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Material</label>
                          <Select
                            className="search-dm"
                            name="materials"
                            options={materials}
                            required
                            value={selectedMaterial}
                            onChange={e => {
                              this.onChangeCombo(e, 'selectedMaterial');
                            }}
                            placeholder="Material"
                            isClearable={false}
                            isSearchable
                          />
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">&nbsp;</label>
                          <div className="clearfix" />
                          <a
                            className="gerenciar-categoria"
                            onClick={() => {
                              this.openModal('materialModal');
                            }}
                          >
                            Criar Material
                          </a>
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">Detalhe</label>
                          <Select
                            className="search-dm"
                            name="details"
                            options={details}
                            value={selectedDetail}
                            onChange={e => {
                              this.onChangeCombo(e, 'selectedDetail');
                            }}
                            required
                            placeholder="Detalhe"
                            isClearable={false}
                            isSearchable
                          />
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">&nbsp;</label>
                          <div className="clearfix" />
                          <a
                            className="gerenciar-categoria"
                            onClick={() => {
                              this.openModal('detailModal');
                            }}
                          >
                            Criar Detalhe
                          </a>
                        </div>
                      </div>

                      {/* <div className="bx--row">
                        <div className="bx--col-xs-12 v-md-margin">
                          <label className="bx--label">Onde será aplicado?</label>
                          <div className="clearfix" />
                          <div className="bx--row">
                            {aplicacoes &&
                              aplicacoes.map(obj => (
                                <div
                                  className="bx--col-xs-12 bx--col-md-4"
                                  key={`divAplicacao${obj.id}`}
                                >
                                  <Checkbox
                                    labelText={obj.label}
                                    id={`aplicacao${obj.id}`}
                                    name="aplicacao"
                                    defaultChecked={obj.checked}
                                    onChange={e => this.onChangeAplicacaoCheck(e, obj.id)}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                        <div className="bx--col-xs-12 v-md-margin">
                          <a
                            className="gerenciar-categoria"
                            onClick={() => {
                              this.openModal('aplicacaoModal');
                            }}
                          >
                            Criar Aplicação
                          </a>
                        </div>
                      </div> */}
                      <div className="bx--row">
                        <div className="bx--col-xs-12 v-md-margin">
                          <label className="bx--label">Tamanhos</label>
                          <div className="clearfix" />
                          <div className="bx--row">
                            {tamanhos &&
                              tamanhos.map((obj) => (
                                <div
                                  className="bx--col-xs-12 bx--col-md-4"
                                  key={`divTamanhos ${obj.id}`}
                                >
                                  <Checkbox
                                    labelText={obj.label}
                                    id={`tamanho${obj.id}`}
                                    name="tamanho"
                                    checked={!!obj.checked}
                                    onChange={() => this.onChangeTamanhoCheck(obj)}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                        <div className="bx--col-xs-12 ">
                          <a
                            className="gerenciar-categoria"
                            onClick={() => {
                              this.openModal('tamanhosModal');
                            }}
                          >
                            Criar Tamanho
                          </a>
                        </div>
                      </div>

                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label"> Quantidade Mínima </label>
                          <input
                            type="number"
                            step="1"
                            className="bx--text-input"
                            required
                            placeholder="0 (sem quantidade mínima)"
                            name="QuantidadeMinima"
                            value={QuantidadeMinima !== undefined && QuantidadeMinima !== null ? QuantidadeMinima : ''}
                            onChange={this.onChangeNumber}
                          />
                        </div>
                      </div>
                      {unidadeMedidaSelecionada &&
                        (
                          <div className="bx--row">
                            <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                              <label className="bx--label"> Unidade de Medida para o Preço </label>
                              <Select
                                className="search-dm"
                                name="UnidadeMedida"
                                required
                                options={unidadesMedida}
                                value={unidadeMedidaSelecionada}
                                onChange={e => {
                                  this.onChangeCombo(e, 'unidadeMedidaSelecionada');
                                }}
                                placeholder="Unidade de Medida para o Preço"
                                isClearable={false}
                                isSearchable
                                disabled
                              />
                            </div>
                          </div>
                        )
                      }

                      {/* <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label"> Tag de Preço </label>
                          <Select
                            className="search-dm"
                            name="grupos"
                            options={tagsPrices}
                            required
                            value={selectedTagPrice}
                            onChange={this.onChangeTagPrice}
                            placeholder="Selecione a tag de preço desejada"
                            isClearable={false}
                            isSearchable
                          />
                        </div>


                        <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                          <label className="bx--label">&nbsp;</label>
                          <div className="clearfix" />
                          <a className="gerenciar-categoria" onClick={() => this.openModal('tagPriceModal')}>
                            Criar TAG
                          </a>
                        </div>
                      </div> */}
                      <div className="bx--row">
                        <div>
                          {selectedTagPrice && selectedTagPrice.precoReferencia > 0 && (
                            <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                              <label className="bx--label"> Valor de Referência da Tag </label>
                              <NumberFormat

                                id="precoFornecedor"
                                className="bx--text-input bx--text__input"
                                decimalSeparator=","
                                prefix="R$ "
                                fixedDecimalScale
                                thousandSeparator="."
                                placeholder="R$ 0,00"
                                value={selectedTagPrice.precoReferencia}
                                allowNegative={false}
                                decimalScale={2}
                                disabled="true"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12">
                          <Checkbox
                            className="v-lg-margin"
                            labelText="Upload de Referência Obrigatório"
                            id="UploadReferenciaObrigatorio"
                            name="UploadReferenciaObrigatorio"
                            checked={!!UploadReferenciaObrigatorio}
                            onChange={this.onChangeCheck}
                          />
                        </div>
                        <div className="bx--col-xs-12">
                          <Checkbox
                            className="v-lg-margin"
                            labelText="Briefing Obrigatório"
                            id="BriefingObrigatorio"
                            name="BriefingObrigatorio"
                            checked={!!BriefingObrigatorio}
                            onChange={this.onChangeCheck}
                          />
                        </div>
                      </div>

                      <div className="bx--row">
                        <FileUploader
                          labelTitle="Imagens"
                          labelDescription=" Máx 500x500 px / 500kb "
                          buttonLabel="Upload"
                          filenameStatus="edit"
                          onChange={async e => {
                            await this.fileChange(e, 'imagens');
                          }}
                          buttonKind="secondary"
                          multiple
                          ref={fileUploader => (this.fileUploader = fileUploader)}
                          accept={['.jpg', '.png']}
                          name="imagens"
                        />
                      </div>
                      <div className="bx--row">
                        {fotos &&
                          fotos.map(foto => (
                            <div key={`f${foto.id}`} style={{ width: '100%', marginTop: '10px' }}>
                              <div className="clearfix" />
                              <img
                                src={IMAGE_PATH + foto.caminho}
                                alt="Miniatura"
                                className="img-produto-miniatura"
                              />
                              <div className="bx--file-container">
                                <span className="bx--file__selected-file" kind="secondary">
                                  <p className="bx--file-filename">
                                    {' '}
                                    {foto.caminho && foto.caminho.split('/').pop()}
                                    {' '}
                                  </p>
                                  <span
                                    className="bx--file__state-container"
                                    onClick={async () => {
                                      await this.deleteFoto(foto.id);
                                    }}
                                  >
                                    <svg
                                      className="bx--file-close"
                                      fillRule="evenodd"
                                      height="16"
                                      role="img"
                                      viewBox="0 0 16 16"
                                      width="16"
                                      tabIndex="0"
                                      aria-label="Provide icon description"
                                      alt="Provide icon description"
                                    >
                                      <title>Provide icon description</title>
                                      <path d="M8 6.586L5.879 4.464 4.464 5.88 6.586 8l-2.122 2.121 1.415 1.415L8 9.414l2.121 2.122 1.415-1.415L9.414 8l2.122-2.121-1.415-1.415L8 6.586zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                                    </svg>
                                  </span>
                                </span>
                              </div>
                            </div>
                          ))}
                      </div>
                      <div className="bx--row" style={{ marginTop: '40px' }}>
                        <div className="bx--col-xs-12 v-md-margin">
                          <Button type="submit">Salvar</Button>
                          <a onClick={() => this.goUrl()} className="bx--link mg-left-20 pointer">
                            Cancelar
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </Card>
              </div>
              {deleteModal &&
                (
                  <Modal
                    modalHeading="Remover Produto"
                    primaryButtonText="Confirmar"
                    secondaryButtonText="Cancelar"
                    onRequestSubmit={this.deletarProduto}
                    onRequestClose={() => this.cleseModal('deleteModal')}
                    open={deleteModal}
                  >
                    <p>Você deseja realmente deletar este produto?</p>
                  </Modal>
                )
              }

              {grupoModal && (
                <Modal
                  open={grupoModal}
                  onRequestSubmit={async () => {
                    await this.criarGrupo();
                  }}
                  onRequestClose={() => this.cleseModal('grupoModal')}
                  modalHeading="Criar Grupo"
                  primaryButtonText="Confirmar"
                  secondaryButtonText="Cancelar"
                  primaryButtonDisabled={!(nomeGrupo && descricaoGrupo)}
                >
                  <div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Nome do grupo</label>
                        <input
                          type="text"
                          className="bx--text-input"
                          required
                          placeholder="Nome"
                          name="nomeGrupo"
                          value={nomeGrupo}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-md-12 bx--col-xs-12">
                        <Checkbox
                          className=" check-uniq"
                          labelText="Permitir multiseleção de tamanhos"
                          id="MultSelecaoTamanhos"
                          name="MultSelecaoTamanhos"
                          checked={!!MultSelecaoTamanhos}
                          onChange={this.onChangeCheck}
                        />

                        <Checkbox
                          className=" check-uniq"
                          labelText="Disponível em campanha promocional"
                          id="UtilizadoEmTrade"
                          name="UtilizadoEmTrade"
                          checked={!!UtilizadoEmTrade}
                          onChange={this.onChangeCheck}
                        />
                      </div>

                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 v-lg-margin">
                        <TextArea
                          labelText="Descrição"
                          name="descricaoGrupo"
                          value={descricaoGrupo}
                          onChange={this.onChangeText}
                          placeholder="Digite"
                        />
                      </div>
                    </div>
                  </div>
                </Modal>
              )

              }
              {productModal && (
                <Modal
                  open={productModal}
                  onRequestSubmit={async () => {
                    await this.createProduct();
                  }}
                  onRequestClose={() => this.cleseModal('productModal')}
                  modalHeading="Criar Nome do Produto"
                  primaryButtonText="Confirmar"
                  secondaryButtonText="Cancelar"
                  primaryButtonDisabled={!(productName && productDescription && gruposelecionada)}
                >
                  <div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Grupo</label>
                        <Select
                          className="search-dm"
                          name="grupos"
                          options={grupos}
                          required
                          value={gruposelecionada}
                          onChange={this.onChangeGrupo}
                          placeholder="Grupo"
                          isClearable={false}
                          isSearchable
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Nome do Produto</label>
                        <input
                          type="text"
                          className="bx--text-input"
                          required
                          placeholder="Nome do Produto"
                          name="productName"
                          value={productName}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12">
                        <TextArea
                          labelText="Descrição Resumida"
                          name="productDescription"
                          value={productDescription}
                          onChange={this.onChangeText}
                          placeholder="Digite"
                        />
                      </div>
                    </div>
                  </div>
                </Modal>
              )}

              {materialModal && (
                <Modal
                  open={materialModal}
                  onRequestSubmit={async () => {
                    await this.createMaterial();
                  }}
                  onRequestClose={() => this.cleseModal('materialModal')}
                  modalHeading="Criar Material"
                  primaryButtonText="Confirmar"
                  secondaryButtonText="Cancelar"
                  primaryButtonDisabled={!materialName}
                >
                  <div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Grupo</label>
                        <Select
                          className="search-dm"
                          name="grupos"
                          options={grupos}
                          required
                          value={gruposelecionada}
                          onChange={this.onChangeGrupo}
                          placeholder="Grupo"
                          isClearable={false}
                          isSearchable
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Material</label>
                        <input
                          type="text"
                          className="bx--text-input"
                          required
                          placeholder="Material"
                          name="materialName"
                          value={materialName}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                  </div>
                </Modal>
              )}

              {detailModal && (
                <Modal
                  open={detailModal}
                  onRequestSubmit={async () => {
                    await this.createDetail();
                  }}
                  onRequestClose={() => this.cleseModal('detailModal')}
                  modalHeading="Criar Detalhe de Produto"
                  primaryButtonText="Confirmar"
                  secondaryButtonText="Cancelar"
                  primaryButtonDisabled={!(detailName && gruposelecionada && selectedProduct)}
                >
                  <div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Grupo</label>
                        <Select
                          className="search-dm"
                          name="grupos"
                          options={grupos}
                          required
                          value={gruposelecionada}
                          onChange={this.onChangeGrupo}
                          placeholder="Grupo"
                          isClearable={false}
                          isSearchable
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Nome do Produto</label>
                        <Select
                          className="search-dm"
                          name="products"
                          options={products}
                          required
                          value={selectedProduct}
                          onChange={e => {
                            this.onChangeCombo(e, 'selectedProduct');
                          }}
                          placeholder="Nome do Produto"
                          isClearable={false}
                          isSearchable
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Detalhe do Produto</label>
                        <input
                          type="text"
                          className="bx--text-input"
                          required
                          placeholder="Detalhe do Produto"
                          name="detailName"
                          value={detailName}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                  </div>
                </Modal>
              )}

              {aplicacaoModal && (
                <Modal
                  open={aplicacaoModal}
                  onRequestSubmit={async () => {
                    await this.createAplicacao();
                  }}
                  onRequestClose={() => this.cleseModal('aplicacaoModal')}
                  modalHeading="Criar Aplicação"
                  primaryButtonText="Confirmar"
                  secondaryButtonText="Cancelar"
                  primaryButtonDisabled={!aplicacaoNome}
                >
                  <div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Nome da Aplicação</label>
                        <input
                          type="text"
                          className="bx--text-input"
                          required
                          placeholder="Nome da Aplicação"
                          name="aplicacaoNome"
                          value={aplicacaoNome}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label"> Exige complemento? </label>
                        <div className="clearfix" />
                        <div className="inline-radio">
                          <RadioButton
                            name="aplicacaoComplemento"
                            onChange={this.onChangeComplemento}
                            checked={aplicacaoComplemento === 1}
                            value={1}
                            labelText="Sim"
                          />
                          <RadioButton
                            name="aplicacaoComplemento"
                            onChange={this.onChangeComplemento}
                            checked={aplicacaoComplemento !== 1}
                            value={0}
                            labelText="Não"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-xs-12 bx--col-md-6">
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                          <Checkbox
                            className="v-lg-margin"
                            labelText="Único"
                            id="aplicacaoUnico"
                            name="aplicacaoUnico"
                            checked={!!aplicacaoUnico}
                            onChange={this.onChangeCheck}
                          />
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                          <Checkbox
                            className="v-lg-margin"
                            labelText="Fracionado"
                            id="aplicacaoFracionado"
                            name="aplicacaoFracionado"
                            checked={!!aplicacaoFracionado}
                            onChange={this.onChangeCheck}
                          />
                        </div>
                        <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                          <Checkbox
                            className="v-lg-margin"
                            labelText="Sequencial"
                            id="aplicacaoSequencial"
                            name="aplicacaoSequencial"
                            checked={!!aplicacaoSequencial}
                            onChange={this.onChangeCheck}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              )}

              {tamanhosModal && (
                <Modal
                  className="ofauto"
                  open={tamanhosModal}
                  onRequestSubmit={async () => {
                    await this.createTamanho();
                  }}
                  onRequestClose={() => this.cleseModal('tamanhosModal')}
                  modalHeading=" Criar Tamanho "
                  primaryButtonText="Confirmar"
                  secondaryButtonText="Cancelar"
                  primaryButtonDisabled={
                    !(
                      tamanhoNome &&
                      gruposelecionada &&
                      unidadeMedidaTamanho &&
                      ((tamanhoAltura && tamanhoLargura) || (!tamanhoAltura && !tamanhoLargura))
                    )
                  }
                >
                  <div>

                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Nome do Tamanho</label>
                        <input
                          type="text"
                          className="bx--text-input"
                          required
                          placeholder="Nome do Tamanho"
                          name="tamanhoNome"
                          value={tamanhoNome}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Medidas</label>
                        <Select
                          className="search-dm"
                          name="products"
                          options={unidadesMedida}
                          required
                          value={unidadeMedidaTamanho}
                          onChange={e => {
                            this.onChangeCombo(e, 'unidadeMedidaTamanho');
                          }}
                          placeholder="Selecione"
                          isClearable={false}
                          isSearchable
                        />
                      </div>
                    </div>
                    <div className="bx--row mg-left-20">
                      <div className="bx--col-xs-12 bx--col-md-12 v-md-margin">
                        <Checkbox
                          id="requiredLarge"
                          className="check-form-sizes"
                          labelText={(
                            <span>
                              Este tamanho será usado em produtos que
                              <strong> não calculam preço e não tem tamanho personalizado </strong>
                              pelo solicitante
                            </span>
                          )}
                          checked={!!tamanhoFixo}
                          onChange={value => {
                            this.setState({ tamanhoFixo: value });
                          }}
                        />
                      </div>
                    </div>
                    {!tamanhoFixo && (
                      <div className="bx--row mg-left-20">
                        <div className="bx--col-xs-12 bx--col-md-9 v-md-margin">
                          <Notification
                            kind="warning"
                            title="Atenção"
                            description={(
                              <p>
                                Marque o flag apenas em produtos que deverão
                                <strong> calcular o preço </strong>
                                e/ou em que o solicitante vá precisar entrar com o tamanho, ou seja
                                <strong> tamanho personalizado </strong>
                                <br />
                                <br />
                                <strong>Marcando o flag não e preenchendo</strong>
                                , o solicitante será obrigado a preencher
                                <br />
                                <br />
                                <strong>Marcando o flag e preenchendo</strong>
                                , o valor será usado junto a
                                <strong> Medida </strong>
                                para cálculo de preços (esse número não é visto pelo solicitante, ele vê apenas o "nome do tamanho")
                              </p>
                            )}
                          />
                        </div>
                      </div>
                    )}
                    <div className="bx--row" style={{ maxWidth: '496px' }}>
                      <div className="bx--col-xs-12 bx--col-md-1 v-md-margin">
                        <Checkbox
                          className="v-lg-margin"
                          labelText=""
                          id="tamanhoLarguraObrigatoria"
                          name="tamanhoLarguraObrigatoria"
                          checked={!!tamanhoLarguraObrigatoria}
                          onChange={this.onChangeCheck}
                        />
                      </div>
                      <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                        <label className="bx--label">Largura</label>
                        <input
                          type="number"
                          className="bx--text-input"
                          required
                          placeholder="Largura"
                          name="tamanhoLargura"
                          value={tamanhoLargura !== undefined && tamanhoLargura !== null ? tamanhoLargura : ''}
                          onChange={this.onChangeNumber}
                        />
                      </div>
                    </div>
                    <div className="bx--row" style={{ maxWidth: '496px' }}>
                      <div className="bx--col-xs-12 bx--col-md-1 v-md-margin">
                        <Checkbox
                          className="v-lg-margin"
                          labelText=""
                          id="tamanhoAlturaObrigatoria"
                          name="tamanhoAlturaObrigatoria"
                          checked={!!tamanhoAlturaObrigatoria}
                          onChange={this.onChangeCheck}
                        />
                      </div>
                      <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                        <label className="bx--label">Altura</label>
                        <input
                          type="number"
                          className="bx--text-input"
                          required
                          placeholder="Altura"
                          name="tamanhoAltura"
                          value={tamanhoAltura !== undefined && tamanhoAltura !== null ? tamanhoAltura : ''}
                          onChange={this.onChangeNumber}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="bx--col-xs-12 bx--col-md-4 v-md-margin">
                        <label className="bx--label">Grupo</label>
                        <Select
                          className="search-dm"
                          name="grupos"
                          options={grupos}
                          required
                          value={gruposelecionada}
                          onChange={this.onChangeGrupo}
                          placeholder="Grupo"
                          isClearable={false}
                          isSearchable
                        />
                      </div>
                    </div>
                  </div>
                </Modal>
              )
              }


              {tagPriceModal && (
                <div className="md-tag-price">
                  <ModalDm
                    openModal={() => this.openModal('tagPriceModal')}
                    heading="Criar Tag de Preço"
                    hiddenModal={() => this.cleseModal('tagPriceModal')}
                    openMd={tagPriceModal}
                  >
                    <div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-10 v-md-margin">
                          <label className="bx--label">Nome da Tag</label>
                          <input
                            className="bx--text-input"
                            required
                            type="text"
                            name="nameTagPrice"
                            value={nameTagPrice}
                            placeholder="Digite um nome para tag"
                            onChange={e => this.onChangeNameTag(e)}
                          />
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-md-12 bx--col-sm-12 bx--col-xs-12">
                          <Checkbox
                            className="v-lg-margin"
                            labelText="Orçamento Obrigatório"
                            id="OrcamentoObrigatorio"
                            name="OrcamentoObrigatorio"
                            checked={!!OrcamentoObrigatorio}
                            onChange={this.onChangeCheck}
                          />
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-10 v-md-margin">
                          <label className="bx--label">Preço de Referência</label>
                          <NumberFormat
                            getInputRef={ref => {
                              this.precoReferenciaTag = ref;
                            }}
                            id="precoFornecedor"
                            className="bx--text-input bx--text__input"
                            decimalSeparator=","
                            prefix="R$ "
                            fixedDecimalScale
                            name="precoReferenciaTag"
                            thousandSeparator="."
                            placeholder="R$ 0,00"
                            value={
                              precoReferenciaTag && precoReferenciaTag.floatValue >= 0
                                ? precoReferenciaTag.floatValue
                                : ''
                            }
                            onValueChange={e => this.onChangePriceTag(e)}
                            allowNegative={false}
                            decimalScale={2}
                          />
                        </div>
                      </div>
                      <div className="bx--row">
                        <div className="bx--col-xs-12 bx--col-md-10 v-md-margin">
                          <label className="bx--label"> Unidade de Medida para o Preço </label>
                          <Select
                            className="search-dm"
                            name="UnidadeMedida"
                            required
                            options={unidadesMedida}
                            value={unidadeMedidaTag}
                            onChange={e => {
                              this.onChangeCombo(e, 'unidadeMedidaTag');
                            }}
                            placeholder="Unidade de Medida para o Preço"
                            isClearable={false}
                            isSearchable
                          />
                        </div>
                      </div>
                      <div className="bx--row mg-left-20" style={{ marginBottom: 20 }}>
                        <div className="bx--col-md-12 bx--col-xs-12">
                          <label className="bx--label">Grupos</label>
                        </div>
                        {listGroups && listGroups.map(item => (
                          <div className="bx--col-md-6 bx--col-xs-12">
                            <Checkbox
                              labelText={item.label}
                              id={`grupo${item.id}`}
                              name="grupos"
                              value={item.id}
                              checked={!!item.selected}
                              onChange={(e) => { this.onCheckGroup(e, item.id) }}
                            />
                          </div>
                        ))}
                      </div>
                      {fornecedoresTag.length > 0 && (
                        <React.Fragment>
                          <div className="bx--row animated fadeIn v-md-margin">
                            <div className="bx--col-xs-9 bx--col-md-5 ">
                              <label className="bx--label">Fornecedor</label>
                              <Select
                                className="search-dm"
                                name="fornecedorTag"
                                options={fornecedoresTag}
                                value={selectedFornecedorTag}
                                onChange={this.onChangeFornecedorTag}
                                placeholder="Fornecedor"
                                isClearable={false}
                                isSearchable
                              />
                            </div>
                            <div className="bx--col-xs-12 bx--col-md-5 ">
                              <label className="bx--label">Preço do Fornecedor</label>
                              <NumberFormat
                                getInputRef={ref => {
                                  this.precoFornecedor = ref;
                                }}
                                id="precoFornecedor"
                                className="bx--text-input bx--text__input"
                                decimalSeparator=","
                                prefix="R$ "
                                fixedDecimalScale
                                name="precoFornecedor"
                                thousandSeparator="."
                                placeholder="R$ 0,00"
                                value={precoFornecedor && precoFornecedor.floatValue ? precoFornecedor.floatValue : ""}
                                onValueChange={e => this.onChangePriceProviders(e)}
                                allowNegative={false}
                                decimalScale={2}
                              />
                            </div>
                            <div className="bx--col-xs-3 bx--col-md-2">
                              <button
                                kind="ghost"
                                type="button"
                                className="button button--clear button--icon"
                                style={{ height: "5px", marginTop: "5px" }}
                                onClick={() => this.addFornecedorTag()}
                                disabled={disabledBtnAddProviders}
                              >
                                <i className="material-icons">add_circle</i>
                              </button>
                            </div>
                          </div>
                        </React.Fragment>
                      )}
                      {providerSelecteds.length > 0 && (
                        <React.Fragment>
                          {providerSelecteds.map((item, index) => (
                            <div className="bx--row animated fadeIn v-md-margin">

                              <div className="bx--col-xs-9 bx--col-md-5 v-md-margin">
                                <label className="bx--label">{`Fornecedor #${index + 1}`}</label>
                                <Select
                                  className="search-dm"
                                  name="fornecedorTag"
                                  options={fornecedoresTag}
                                  required
                                  value={item.selectedFornecedorTag}
                                  onChange={this.onChangeFornecedorList}
                                  placeholder="Fornecedor"
                                  isClearable={false}
                                  disabled
                                />
                              </div>
                              <div className="bx--col-xs-12 bx--col-md-5  v-md-margin">
                                <label className="bx--label">Preço do Fornecedor</label>
                                <NumberFormat
                                  getInputRef={ref => {
                                    this.precoFornecedor = ref;
                                  }}
                                  id="precoFornecedor"
                                  className="bx--text-input bx--text__input"
                                  decimalSeparator=","
                                  prefix="R$ "
                                  fixedDecimalScale
                                  name="precoFornecedor"
                                  thousandSeparator="."
                                  placeholder="R$ 0,00"
                                  onValueChange={e => this.editPrecoFornecedor(e, index)}
                                  value={item.precoFornecedor && item.precoFornecedor.floatValue ? item.precoFornecedor.floatValue : ""}
                                  allowNegative={false}
                                  decimalScale={2}
                                />
                              </div>

                              <div className="bx--col-xs-3 bx--col-md-2">
                                <button
                                  kind="ghost"
                                  type="button"
                                  className="button button--clear button--icon danger"
                                  onClick={() => this.removeProviderSelectedts(index)}

                                >
                                  <i className="material-icons">cancel</i>
                                </button>
                              </div>
                            </div>
                          ))}
                        </React.Fragment>
                      )}


                      <div className="bx--modal-footer footer-md-tags">
                        <button
                          className="bx--btn btn-secondary-outlined"
                          type="button"
                          onClick={() => this.cleseModal('tagPriceModal')}
                        >
                          Cancelar
                        </button>
                        <button
                          className="bx--btn btn-secondary-color"
                          type="button"
                          onClick={() => this.saveTagPrice()}
                        >
                          Criar
                        </button>
                      </div>
                      <Modal
                        open={openMdConfirmFree}
                        onRequestSubmit={() => this.closeConfirmTag(true)}
                        onRequestClose={() => this.closeConfirmTag(false)}
                        modalHeading="Produto Gratuito"
                        primaryButtonText="Sim"
                        secondaryButtonText="Não"
                      >
                        <h3>
                          Não tem valor no preço de referência. Deseja salvar este produto como gratuito?
                        </h3>
                      </Modal>
                    </div>
                  </ModalDm>
                </div>
              )}
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default Agencia;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/Edit/Agencia.js